<template>
  <div class="sidebar-container">
    <!-- 标题区域 -->
    <div class="logo-container">
      <img src="@/assets/logo.jpg" class="logo" />
      <h1 class="logo-title">润芯管家</h1>
    </div>

    <el-menu
      :default-active="activeMenu"
      class="el-menu-vertical"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
      router
    >
      <sidebar-item
        v-for="item in filteredTreeMenu"
        :key="item.ownId"
        :menu="item"
      />
    </el-menu>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { menuList } from "@/utils/menu";

export default {
  name: "Sidebar",
  components: {
    SidebarItem: {
      name: "SidebarItem",
      props: {
        menu: Object,
      },
      render(h) {
        // 从组件的 props 中取出菜单项对象
        const { menu } = this;
        // 获取菜单项的路由路径（如果有），没有则为空字符串
        const routeIndex = menu.route_path || "";

        // 判断当前菜单项是否有子菜单（children 且长度大于0）
        if (menu.children && menu.children.length) {
          // 如果有子菜单，渲染一个带下拉功能的菜单项（el-submenu）
          return h(
            "el-submenu",
            {
              props: {
                // 给 el-submenu 绑定一个唯一标识，优先使用路由路径，
                // 路由路径没有再用菜单 code，code 也没有则用 ownId 转字符串
                index: routeIndex || menu.code || String(menu.ownId),
              },
            },
            [
              // 这里是菜单标题部分，slot 名为 title
              h("template", { slot: "title" }, [
                // 如果有图标，则渲染图标
                menu.icon ? h("i", { class: menu.icon }) : null,
                // 显示菜单名称
                h("span", menu.name),
              ]),
              // 递归渲染子菜单项，每个子菜单项作为 sidebar-item 组件传入对应的 menu 对象
              menu.children.map((child) =>
                h("sidebar-item", { props: { menu: child }, key: child.ownId })
              ),
            ]
          );
        } else {
          // 如果没有子菜单，渲染单独的菜单项（el-menu-item）
          return h(
            "el-menu-item",
            {
              props: {
                // 同样给菜单项绑定唯一标识，用于菜单的路由高亮等功能
                index: routeIndex || menu.code || String(menu.ownId),
              },
            },
            [
              // 如果有图标则显示图标
              menu.icon ? h("i", { class: menu.icon }) : null,
              // 显示菜单名称
              h("span", menu.name),
            ]
          );
        }
      },
    },
  },
  computed: {
    ...mapState(["userPermissions"]), // 这里 userPermissions 是后端返回的 code 字符串数组

    activeMenu() {
      const path = this.$route.path;
      if (path.startsWith("/admin/")) return path;
      if (path.startsWith("/material-management/log/")) return path;
      return path;
    },

    filteredTreeMenu() {
       console.log("permissionSet",this.userPermissions);

      if (!this.userPermissions || !this.userPermissions.length) {
        return [];
      }
      // 先把 userPermissions 转成 Set 加速查找
      const permissionSet = new Set(this.userPermissions.map((p) => p.code));

     
      const filtered = menuList
        .filter((item) => item.code && permissionSet.has(item.code))
        .map((it) => {
          // 找到 userPermissions 里对应的权限对象
          const perm = this.userPermissions.find((p) => p.code === it.code);
          if (perm) {
            // 返回合并对象，parentId 和 endType 取自 perm
            return {
              ...it,
              parent_id: perm.parentId, // 注意大小写按你后端返回字段，前端保持一致
              end_type: perm.endType,
              id: perm.id,
            };
          }
          return it;
        });

      // 只拿公开菜单（排除已经包含在filtered里的）
      const publicMenus = menuList.filter(
        (item) =>
          item.is_public && !filtered.find((f) => f.ownId === item.ownId)
      );

      // 最后把公开菜单追加到最后
      const finalList = filtered.concat(publicMenus);

      console.log("finalList", finalList);

      // 构造树形结构
      return this.buildTree(finalList);
    },
  },
  methods: {
    buildTree(list) {
      const map = {};
      const roots = [];

      list.forEach((item) => {
        map[item.id] = { ...item, children: [] };
      });

      list.forEach((item) => {
        if (
          item.parent_id !== undefined &&
          item.parent_id !== null &&
          item.parent_id !== -1 &&
          map[item.parent_id]
        ) {
          map[item.parent_id].children.push(map[item.id]);
        } else {
          roots.push(map[item.id]);
        }
      });

      return roots;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 你的样式保持不变 */
.sidebar-container {
  .logo-container {
    height: 60px;
    padding: 10px 0;
    text-align: center;
    background-color: #2b2f3a;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;

    .logo-title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
      margin: 0;
      line-height: 40px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .el-menu {
    border: none;
    height: calc(100% - 60px);
    width: 100% !important;
  }
}
.logo {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
}
</style>
